export enum EModalidadeEmissaoNFe {
  EmissaoNormal = 1,
  ContingenciaFSIA = 2,
  ContingenciaSCAN = 3,
  ContingenciaDPEC = 4,
  ContingenciaFSDA = 5,
  ContingenciaSVCAN = 6,
  ContingenciaSVCRS = 7,
}
